module.exports = __webpack_public_path__ + "img/icon-arrow-triangle-shadow2-yellow.c759bf56.svg";